<template>
  <v-row :class="$vuetify.breakpoint.mdAndUp ? 'flex-nowrap' : ''">
    <v-col cols="12" sm="7" lg="8">
      <v-card class="half-radius pl-4 pr-5 py-9 shadow">
        <div
          class="overflow-y-auto overflow-x-hidden custom-scroll py-5"
          style="max-height: 80vh"
        >
          <v-form @submit.prevent v-model="form">
            <v-row
              v-for="(answer, index) in answers"
              :key="'Question ' + index"
              dense
            >
              <v-col cols="auto">
                <v-avatar
                  size="27"
                  color="#168EEA"
                  class="white--text body-2 custom-avatar"
                  >{{ index + 1 }}</v-avatar
                >
              </v-col>
              <v-col
                cols="12"
                sm="10"
                md="8"
                class="pl-4 pt-2 custom-text body-2"
              >
                <span class="d-block">{{
                  questions[index] ? questions[index].content : ''
                }}</span>
                <span
                  v-if="index === 0"
                  class="mb-6 d-block font-weight-bold"
                  >{{ questions[index].good_answer }}</span
                >
                <v-text-field
                  v-else
                  dense
                  :readonly="finished"
                  placeholder="Your answer goes here"
                  v-model="answer.content"
                  :class="!!answer.content ? 'body-2' : 'font-italic caption'"
                />
              </v-col>
              <v-col
                cols="12"
                class="pl-8 pr-4"
                :style="$vuetify.breakpoint.xs ? '' : 'padding-right: 60px !important'"
              >
                <v-divider
                  class="custom-divider"
                  v-if="index < questions.length - 1"
                ></v-divider>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-6">
              <v-btn
                v-if="!finished"
                small
                depressed
                :disabled="!form || finished"
                width="100"
                :loading="loading"
                class="white--text text-capitalize"
                color="#29284c"
                @click="onFinish"
                >Finish</v-btn
              >
              <ProgressResetButton
                v-else
                :stepType="stepType"
                :stepUuid="stepUuid"
                @reset="onReset"
              />
            </v-row>
          </v-form>
        </div>
      </v-card>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto">
      <app-answer-key
        add-content
        split-char=")"
        hide-hint
        :finished="finished"
        :questions="questions"
      />
    </v-col>
  </v-row>
</template>
<script>
import AnswerKey from './../AnswerKey.vue';
import studentMixin from '@/mixins/studentMixin';
import answerMixin from '@/mixins/answerMixin';
import ProgressResetButton from '@/components/Utils/ProgressResetButton.vue';

export default {
  components: {
    appAnswerKey: AnswerKey,
    ProgressResetButton,
  },
  mixins: [studentMixin, answerMixin],
  props: {
    stepUuid: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: false,
      rules: {
        required: v => !!v || 'Required',
      },
    };
  },
};
</script>
<style scoped>
.custom-divider {
  border-top: 1px #f5f6f7 dashed;
}
.custom-avatar {
  border: 1px #c5eeff solid !important;
}
.v-avatar {
  margin-top: 2px;
}
.custom-scroll::-webkit-scrollbar {
  width: 7px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #29284c !important;
  border-radius: 20px;
}
</style>
